import React from 'react';
import { Box, Container, Typography, Paper, Button } from '@mui/material';
import { useNavigate } from 'react-router-dom';
import ArrowBackIcon from '@mui/icons-material/ArrowBack';

const CookiePolicy = () => {
  const navigate = useNavigate();

  return (
    <Box
      sx={{
        py: 8,
        mt: 8,
        minHeight: '100vh',
        bgcolor: 'background.default',
      }}
    >
      <Container maxWidth="lg">
        <Button
          startIcon={<ArrowBackIcon />}
          onClick={() => navigate('/')}
          sx={{
            mb: 4,
            color: 'primary.main',
            '&:hover': {
              backgroundColor: 'rgba(108, 59, 248, 0.08)',
            },
          }}
        >
          Back to Home
        </Button>

        <Paper
          elevation={0}
          sx={{
            p: 4,
            borderRadius: 2,
            border: '1px solid',
            borderColor: 'divider',
          }}
        >
          <Typography variant="h3" component="h1" gutterBottom>
            Cookie Policy
          </Typography>
          
          <Typography variant="body1" paragraph>
            Last updated: {new Date().toLocaleDateString()}
          </Typography>

          <Typography variant="h5" gutterBottom sx={{ mt: 4 }}>
            1. What Are Cookies
          </Typography>
          <Typography variant="body1" paragraph>
            Cookies are small text files that are placed on your computer or mobile device when you visit a website. They are widely used to make websites work more efficiently and provide a better user experience, as well as to provide information to the owners of the site.
          </Typography>

          <Typography variant="h5" gutterBottom sx={{ mt: 4 }}>
            2. How We Use Cookies
          </Typography>
          <Typography variant="body1" paragraph>
            We use cookies for the following purposes:
          </Typography>
          <Typography component="ul" sx={{ pl: 4 }}>
            <li>Essential cookies: Required for the operation of our website</li>
            <li>Analytical/performance cookies: Allow us to recognize and count visitors</li>
            <li>Functionality cookies: Used to recognize you when you return to our website</li>
            <li>Targeting cookies: Record your visit, pages visited, and links followed</li>
          </Typography>

          <Typography variant="h5" gutterBottom sx={{ mt: 4 }}>
            3. Types of Cookies We Use
          </Typography>
          <Typography variant="body1" paragraph>
            The specific types of first and third party cookies served through our website and their purposes are:
          </Typography>
          <Typography component="ul" sx={{ pl: 4 }}>
            <li>Session Cookies: Temporary cookies that expire when you close your browser</li>
            <li>Persistent Cookies: Remain on your device until you delete them or they expire</li>
            <li>Performance Cookies: Collect information about how you use our website</li>
            <li>Authentication Cookies: Help us identify you when you're logged in</li>
          </Typography>

          <Typography variant="h5" gutterBottom sx={{ mt: 4 }}>
            4. Managing Cookies
          </Typography>
          <Typography variant="body1" paragraph>
            Most web browsers allow you to control cookies through their settings preferences. However, if you limit the ability of websites to set cookies, you may worsen your overall user experience. To manage your cookie preferences, you can:
          </Typography>
          <Typography component="ul" sx={{ pl: 4 }}>
            <li>Adjust your browser settings to notify you when you receive a cookie</li>
            <li>Block third party cookies or all cookies</li>
            <li>Delete cookies manually or automatically when you close your browser</li>
            <li>Use private/incognito mode when browsing</li>
          </Typography>

          <Typography variant="h5" gutterBottom sx={{ mt: 4 }}>
            5. Your Consent
          </Typography>
          <Typography variant="body1" paragraph>
            By continuing to use our website, you consent to our use of cookies as described in this policy. You can withdraw your consent at any time by adjusting your browser settings or clearing your cookies.
          </Typography>

          <Typography variant="h5" gutterBottom sx={{ mt: 4 }}>
            6. Contact Us
          </Typography>
          <Typography variant="body1" paragraph>
            If you have any questions about our use of cookies, please contact us at:
          </Typography>
          <Typography variant="body1" paragraph>
            Email: info@thesmod.com
          </Typography>
        </Paper>
      </Container>
    </Box>
  );
};

export default CookiePolicy; 